import React, { useContext } from 'react';
import { Translate } from 'core/translate';
import AppContext from '../AppContext';
import { ButtonText, PrimaryButton } from 'core/controls';
import { get } from 'lodash';

const VehicleCard = ({ modelData, onViewInventoryClicked }) => {
  const { baseUrl, variant } = useContext(AppContext);
  const {
    brand,
    image,
    year,
    language,
    country,
    carline,
    bodyStyle,
    displayName,
    style,
    drpUrls: urls
  } = modelData;

  const drpBuildUrl = get(urls, 'byo', '');
  const drpViewInventorypUrl = get(urls, 'vs', '');

  const params = `${language}/${country}/${brand}-${variant}/${carline}/${year}/${bodyStyle}`;
  const buildUrl = drpBuildUrl
    ? drpBuildUrl
    : `${baseUrl}${params}${style ? `/config?styleId=${style.styleId}` : ''}`;
  const vsUrl = drpViewInventorypUrl
    ? drpViewInventorypUrl
    : `${baseUrl}vehicle-shopper/${params}${style ? `-${style.code}` : ''}`;
  const normalizedDisplayName = style
    ? `${displayName} ${style.code}`
    : displayName;

  return (
    <div className="vehicle-card">
      <a href={buildUrl} className="vehicle-card__image" tabIndex="-1">
        <img src={image} />
      </a>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="vehicle-card__brand-year">
          <span className="vehicle-card__brand-name">
            <Translate value={brand} />
          </span>{' '}
          | {year}
        </div>
        <div className="vehicle-card__model">{normalizedDisplayName}</div>
        <PrimaryButton as="a" href={buildUrl} style={{ marginTop: 20 }}>
          <ButtonText>
            <Translate value="model.selector.button.text" />
          </ButtonText>
        </PrimaryButton>
        {country === 'US' && (
          <PrimaryButton
            onClick={() => onViewInventoryClicked(vsUrl)}
            style={{ display: 'block', marginTop: 10 }}>
            <ButtonText>
              <Translate value="model.selector.inventory.text" />
            </ButtonText>
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};

export default VehicleCard;
